import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1)}`};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  display: block;
  padding-bottom: ${({ theme }) => theme.spacing(2)};

  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[400]};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li``;

export const WeekDayContainer = styled.button`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
  width: 100%;
  height: 3.2rem;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};
  margin: 0;

  border: none;
  background: transparent;
  text-align: left;

  ${({ as }) =>
    !as &&
    css`
      cursor: pointer;
    `};
`;

export const LabelContainer = styled.span<{
  $hasEntry: boolean;
  $isToday: boolean;
  $overdue: boolean;
}>`
  ${({ theme, $isToday }) =>
    typographyToCss(
      $isToday ? theme.typography.subtitle2 : theme.typography.body2,
    )};
  flex: 1;

  color: ${({ theme, $hasEntry, $overdue }) =>
    $overdue
      ? theme.palette.error.main
      : $hasEntry
        ? theme.palette.text.primary
        : theme.palette.text.secondary};
`;

export const StartIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 2rem;

  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;

export const EndContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const TimeButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};

  padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1.5)}`};
  margin: 0;

  border: ${({ theme }) => `1px solid ${theme.palette.grey[400]}`};
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.background.default};
  cursor: pointer;
  box-shadow: ${({ theme }) =>
    `0 1px 2px 0 ${rgba(theme.palette.common.black, 0.04)}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;
